<template>
  <div class="activity">
    <div class="header">
      <div class="to_back" @click="goBack"/>
      <div class="time_range">活动时间：{{show_time}}</div>
      <div class="title" />
      <div class="levitate">
        <p @click="bill">奖励明细</p>
      </div>
      <div class="box">
        <div class="num">今日剩余宝箱：{{getSurpusNum}}个</div>
        <img :src="treasures"/>
      </div>
      <ul class="nav">
        <li :class="{active: type === 1}" @click="changeBox(1)">初级宝箱</li>
        <li :class="{active: type === 2}" @click="changeBox(2)">中级宝箱</li>
        <li :class="{active: type === 3}" @click="changeBox(3)">高级宝箱</li>
      </ul>
    </div>
    <div class="button_area">
      <div v-if="isSign === false" class="signin" @click="join">立即报名</div>
      <div v-else class="options">
        <div class="open" @click="open">开启宝箱</div>
        <div class="play" @click="jump">继续赚钱</div>
      </div>
    </div>
    <div class="data block">
      <div class="content">
        <div class="cell">
          <p>{{getOpenNum}}</p>
          <p>可开启次数</p>
        </div>
        <div class="line"/>
        <div class="cell">
          <p>{{totalMoney}}</p>
          <p>累计赚取</p>
        </div>
      </div>
    </div>
    <div class="rule block">
      <div class="title">活动规则</div>
      <div class="content">
        <p>1.玩“捕鱼大决战”广告领取的奖励，仅限：“任务奖励+充值奖励”所得的奖励，其他任意榜单均不记入。</p>
        <p>2.超级宝箱：玩家每天累计赚取<font color="red">7元、35元、250元</font>均可开启宝箱，其中初、中级宝箱每日上限5次/日/人，高级宝箱不限次数，多玩多得；</p>
        <p>3.若用户<font color="red">当日赚取35元</font>，可开启<font color="red">5次初级宝箱+1次中级宝箱</font>，以此类推；</p>
        <p>4.本活动为<font color="red">每日活动</font>，当日无论是否达到门槛，次日数据会<font color="red">重新开始计算</font>，还可继续参与活动；（此活动为额外补贴活动，不会消耗任何账户余额）</p>
        <p>5.报名、领奖截止时间为<font color="red">9月2日23:59</font>。只要在活动时间内报名成功的，活动期间内赚取的金币数均可统计。</p>
        <p>6.因商家无法及时返回数据，或游戏数据无法及时更新而延迟发放的试玩奖励不计算在内。</p>
      </div>
    </div>
  
    <van-popup v-model="show" :close-on-click-overlay=false position="top" duration="0">
      <div class="grant">
        <div class="title"><img :src="grantTitle"/></div>
        <div class="grant_moeny">恭喜你获得：<span>{{reward}}元</span></div>
        <div class="open"><img :src="openTreasures" /></div>
        <div class="tips">奖励将直接到账<span>余额</span>哦</div>
        <div class="close" @click="show = false;reward = 0"></div>
      </div>
    </van-popup>

    <loading :isLoad="isLoad"></loading>
  </div>
</template>

<script>
import Primary from '../../assets/images/activity_buyu/box_primary.png'
import Middle from '../../assets/images/activity_buyu/box_middle.png'
import Senior from '../../assets/images/activity_buyu/box_senior.png'

import GrantPrimary from '../../assets/images/activity_buyu/grant_primary.png'
import GrantMiddle from '../../assets/images/activity_buyu/grant_middle.png'
import GrantSenior from '../../assets/images/activity_buyu/grant_senior.png'

import OpenPrimary from '../../assets/images/activity_buyu/open_primary.png'
import OpenMiddle from '../../assets/images/activity_buyu/open_middle.png'
import OpenSenior from '../../assets/images/activity_buyu/open_senior.png'

import Vue from 'vue';
import { Popup, Toast } from 'vant';
import Loading from '@/components/Loading'
Vue.use(Popup).use(Toast);

export default {
  components: {
    Loading
  },
  created() {
    this.userid = this.getCookie('userid')
    this.activityId = this.$route.query.activity_id
    if (this.$route.query.debug == 1) {
      this.userid = this.$route.query.userid
    }
    this.getInfo()
    this.changeBox(this.type)
  },
  data() {
    return {
      userid: '',
      activityId: '',
      type: 1,
      treasures: Primary,
      grantTitle: GrantPrimary,
      openTreasures: OpenPrimary,
      show: false,
      isLoad: false,
      isSign: true,
      totalMoney: 0,
      reward: 0,
      jump_url: '',
      show_time: '',
      // 剩余次数
      num: {
        1: 0,
        2: 0,
        3: 0
      },
      // 剩余积分
      remaining: {
        1: 0,
        2: 0,
        3: 0
      },
      opens: {
        1: 0,
        2: 0,
        3: 0
      }
    }
  },
  computed: {
    // 获取用户可开启剩余数
    getSurpusNum: function() {
      return this.num[this.type]
    },
    // 获取用户可用积分
    getRemainingSum: function() {
      return this.remaining[this.type]
    },
    getOpenNum: function() {
      return this.opens[this.type]
    }
  },
  methods: {
    getCookie: function (name) {
      var strcookie = document.cookie; //获取cookie字符串
      var arrcookie = strcookie.split("; "); //分割
      //遍历匹配
      for (var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split("=");
        if (arr[0] == name) {
          return arr[1];
        }
      }
      return ""
    },
    changeBox: function(type) {
      this.type = type
      switch (type) {
        case 1:
          this.treasures = Primary
          this.grantTitle = GrantPrimary
          this.openTreasures = OpenPrimary
          break
        case 2:
          this.treasures = Middle
          this.grantTitle = GrantMiddle
          this.openTreasures = OpenMiddle
          break
        case 3:
          this.treasures = Senior
          this.grantTitle = GrantSenior
          this.openTreasures = OpenSenior
          break
      }
    },
    open: function () {
      const params = {
        activity_id: this.activityId,
        userid: this.userid,
        treasure_id: this.type
      }

      this.isLoad = true
      this.$http.get('/api/treasure/open', {params: params}).then((res) => {
        this.isLoad = false
        let data = res.data

        if (data.money == 0) {
          let tips
          switch(data.status) {
            case 1:
              tips = '该宝箱今日已经领完啦，请明日在来~'
              break
            case 2:
              tips = '积分不足，玩游戏赚取积分吧~'
              break
            case 3:
              tips = '解锁完前一等级宝箱，才可开启哦~'
              break
          }
          Toast(tips)          
        } else {
          this.getInfo()
          this.reward = data.money
          this.show = true
        }
      })
    },
    join: function () {
      const params = {
        activity_id: this.activityId,
        userid: this.userid
      }
      this.isLoad = true
      this.$http.get('/api/treasure/join', {params: params}).then(() => {
        this.isLoad = false
        this.getInfo()
      })
    },
    getInfo: function () {
      const params = {
        activity_id: this.activityId,
        userid: this.userid
      }

      this.isLoad = true
      this.$http.get('/api/treasure/getInfo', {params: params}).then((res) => {
        this.isLoad = false
        let data = res.data
        this.isSign = data.is_join == 2? true : false
        this.num[1] = data.beginner_level_surplus_num
        this.num[2] = data.intermediate_level_surplus_num
        this.num[3] = data.advanced_level_surplus_num
        this.remaining[1] = data.beginner_level_integral
        this.remaining[2] = data.intermediate_level_integral
        this.remaining[3] = data.advanced_level_integral
        this.opens[1] = data.beginner_level_open_num
        this.opens[2] = data.intermediate_level_open_num
        this.opens[3] = data.advanced_level_open_num
        this.totalMoney = data.money_total
        this.jump_url = data.jump_url
        this.show_time = data.show_time
      })
    },
    bill: function() {
      this.$router.push({path: '/activity/bill', query: {userid: this.userid, activity_id: this.activityId}})
    },
    jump: function () {
      window.location.href = this.jump_url
    },
    goBack: function() {
      window.injectedObject.setJsContent('closeWebview', '')
    },
  }
}
</script>

<style lang="less" scoped>
.activity {
  display: block;
  width: 100%;
  max-width: 3.75rem;
  min-height: 100vh;
  background-color: #1775E5;
  overflow: hidden;

  .header {
    display: block;
    width: 100%;
    height: 4.43rem;
    background: url('~@/assets/images/activity_buyu/header.png') no-repeat;
    background-size: 3.75rem 4.43rem;
    position: relative;
    overflow: hidden;

    .to_back {
      display: block;
      width: .1rem;
      height: .18rem;
      position: absolute;
      background: url('~@/assets/images/activity_buyu/to_back.png') no-repeat;
      background-size: .1rem .18rem;
      left: .17rem;
      top: .35rem;
      overflow: hidden;
    }
    .time_range {
      display: block;
      width: 2rem;
      height: .2rem;
      margin: 0 auto;
      margin-top: .42rem;
      background-image: linear-gradient(270deg, rgba(138,106,105,0.00) 0%, rgba(0,32,140, 0.4) 50%, rgba(143,110,109,0.00) 100%);
      text-shadow: 0 .01rem .02rem;
      color: #FFFFFF;
      line-height: .2rem;
      text-align: center;
      overflow: hidden;
    }
    .title {
      display: block;
      width: 3.33rem;
      height: 1.12rem;
      background: url('~@/assets/images/activity_buyu/title.png') no-repeat;
      background-size: 3.33rem 1.12rem;
      margin: 0 auto;
      margin-top: .02rem;
      overflow: hidden;
    }
    .levitate {
      display: block;
      position: absolute;
      right: 0;
      top: .62rem;
      overflow: hidden;

      p {
        display: block;
        width: .3rem;
        height: .68rem;
        color: #FFFFFF;
        background: rgba(119, 65, 161, 0.7);
        writing-mode:tb-rl;
        border: 1px solid rgba(255,255,255,0.50);
        border-radius: 8px 0 0 8px;
        text-align: center;
        line-height: .3rem;
        overflow: hidden;
      }
    }
    .box {
      display: block;
      width: 100%;
      height: 2.32rem;
      margin-top: .4rem;
      position: relative;

      .num {
        display: block;
        width: 1.16rem;
        height: .29rem;
        font-size: 12px;
        color: #FFFFFF;
        background: url('~@/assets/images/activity_buyu/tips.png') no-repeat;
        background-size: 1.16rem .29rem;
        position: absolute;
        text-align: center;
        line-height: .25rem;
        margin-left: auto;
        margin-right: auto;
        left: 0;
        right: 0;
        top: -0.2rem;
        overflow: hidden;
      }
      img {
        width: 100%;
      }
    }
    .nav {
      display: block;
      width: 2.64rem;
      height: .36rem;
      margin: 0 auto;
      background-image: linear-gradient(180deg, rgba(7, 105, 220, 0.5) 0%, rgba(34, 161, 233, 0.5) 100%);
      border: 2px solid #FFFFFF;
      border-radius: 8px;
      border-radius: 100px;
      position: relative;
      bottom: .52rem;
      overflow: hidden;

      li {
        display: table-cell;
        width: .88rem;
        height: .34rem;
        line-height: .34rem;
        text-align: center;
        font-size: 14px;
        color: #FFFFFF;
        overflow: hidden;
      }
      li.active {
        width: .88rem;
        height: .36rem;
        background-image: linear-gradient(180deg, #FFFD5F 0%, #F3A827 100%);
        border: 2px solid rgba(255, 255, 255, 0.53);
        border-radius: 8px;
        border-radius: 100px;
        transform: translateY(-2px);
        overflow: hidden;
      }
    }
  }
  .button_area {
    display: block;
    width: 100%;
    margin-top: .16rem;
    overflow: hidden;

    .signin {
      display: block;
      width: 3.27rem;
      height: .54rem;
      background-image: linear-gradient(0deg, #FFA423 0%, #FFF8CB 100%);
      box-shadow: 0 2px 8px 0 rgba(120,0,13,0.60), inset 0 4px 8px 0 rgba(0,0,0,0.50), inset 0 -4px 8px 0 rgba(255,255,255,0.75);
      border-radius: 27px;
      border-radius: 100px;
      margin: 0 auto;
      line-height: .54rem;
      text-align: center;
      color: #B33000;
      font-size: 18px;
      overflow: hidden;
    }
    .options {
      display: flex;
      width: 100%;
      justify-content: space-around;

      .open,.play {
        display: block;
        width: 1.5rem;
        height: .48rem;
        line-height: .48rem;
        text-align: center;
        font-size: 16px;
        border-radius: 27px;
        border-radius: 100px;
        overflow: hidden;
      }
      .open {
        color: #FFFFFF;
        background-image: linear-gradient(0deg, #0082FF 0%, #A6F4FF 100%);
        box-shadow: 0 2px 8px 0 rgba(6,55,155,0.88), inset 0 4px 8px 0 rgba(0,0,0,0.50), inset 0 -4px 8px 0 rgba(255,255,255,0.61);
      }
      .play {
        color: rgba(165,75,0,0.85);
        background-image: linear-gradient(0deg, #FFA423 0%, #FFF8CB 100%);
        box-shadow: 0 2px 8px 0 rgba(120,0,13,0.60), inset 0 4px 8px 0 rgba(0,0,0,0.50), inset 0 -4px 8px 0 rgba(255,255,255,0.75);
      }
    }    
  }
  .block {
    display: block;
    width: 3.43rem;
    margin: 0 auto;
    margin-bottom: .16rem;
    background: #4E9FFF;
    box-shadow: 0 2px 8px 0 rgba(0,34,116,0.50), inset 0 1px 7px 0 #7BF0FF;
    border-radius: 5px;
    position: relative;
    overflow: hidden;

    .title {
      display: block;
      min-width: 1rem;
      height: .34rem;
      padding: 0 .4rem;
      line-height: .34rem;
      font-size: 16px;
      color: #FFFFFF;
      text-align: center;
      position: absolute;
      left:50%;
      transform: translate(-50%, 0);
      background: url('~@/assets/images/activity_buyu/title_bg.png') no-repeat;
      background-size: 100% .4rem;
      background-position: center center;
      z-index: 5;
      overflow: hidden;
    }
    .content {
      display: block;
      width: 3.27rem;
      margin: 0 auto;
      margin-top: .08rem;
      margin-bottom: .08rem;
      background: #FFFFFF;
      box-shadow: inset 0 .01rem .08rem 0 rgba(255,70,70,0.65);
      border-radius: 5px;
      overflow: hidden;
    }
    .desc {
      display: block;
      width: 3.03rem;
      margin: 0 auto;
      margin-top: .08rem;
      margin-bottom: .12rem;
      text-align: justify;
      font-size: 12px;
      color: #FFFFFF;
    }
  }
  .data {
    display: block;
    margin-top: .24rem;
    min-height: .77rem;

    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .cell {
        display: block;
        float: left;
        width: 1.63rem;
        height: .77rem;
        text-align: center;
        overflow: hidden;

        p:first-child {
          margin-top: .16rem;
          color: #ED2C23;
          font-size: 16px;
        }
        p:last-child {
          margin-top: .06rem;
          color: #999999;
          font-size: 12px;
        }
      }
      .line {
        display: block;
        float: left;
        width: .01rem;
        height: .3rem;
        background-color: #E6E6E6;
      }
    }
  }
  .rule {
    .content {
      width: 2.79rem;
      padding: .4rem .24rem 0rem .24rem;
      font-size: 14px;

      p {
        color: #333333;
        margin-bottom: .1rem;
      }
    }
  }
  .grant {
    display: block;
    width: 3.75rem;
    min-height: 4.18rem;
    background: transparent;
    background-image: url('~@/assets/images/activity_buyu/grant_bg.png');
    background-size: 3.75rem 4.18rem;
    margin-top: .6rem;
    overflow: hidden;

    .title {
      display: block;
      width: 2.06rem;
      height: .24rem;
      margin: 0 auto;
      margin-top: .4rem;
      overflow: hidden;

      img {
        width: 100%;
      }
    }
    .grant_moeny {
      display: block;
      text-align: center;
      font-size: 18px;
      color: #FFF;
      margin-top: .08rem;
      overflow: hidden;

      span {
        color: rgb(255, 229, 115);
      }
    }
    .open {
      display: block;
      width: 2.47rem;
      margin: 0 auto;
      margin-top: .16rem;
      overflow: hidden;
      
      img {
        width: 100%;
      }
    }
    .tips {
      font-size: 12px;
      margin-top: .1rem;
      text-align: center;
      color: #FFF;

      span {
        color: rgb(247, 222, 112)
      }
    }
  }
  /deep/.van-popup {
    background: transparent;

    .close {
      display: block;
      width: .32rem;
      height: .32rem;
      background: url('~@/assets/images/activity_buyu/close.png') no-repeat;
      background-size: .32rem .32rem;
      margin: 0 auto;
      margin-top: .24rem;
      overflow: hidden;
    }
  }
}
</style>